import type { GenericField } from '@uncinc/react-drupal-core/types';
import { EmploymentType } from '../types/uncinc_profile/nodes';

const translation: { [key in EmploymentType]: { [key: string]: string } } = {
  FULL_TIME: {
    nl: 'Fulltime',
    en: 'Full-time',
  },
  PART_TIME: {
    nl: 'Parttime',
    en: 'Part-time',
  },
  CONTRACTOR: {
    nl: 'ZZP',
    en: 'Freelance',
  },
  TEMPORARY: {
    nl: 'Tijdelijk',
    en: 'Temporary',
  },
  INTERN: {
    nl: 'Stage',
    en: 'Internship',
  },
  VOLUNTEER: {
    nl: 'Vrijwilliger',
    en: 'Volunteer',
  },
  PER_DIEM: {
    nl: 'Per diem',
    en: 'Per diem',
  },
  OTHER: {
    nl: 'Anders',
    en: 'Other',
  },
};

export function translateEmploymentTypes(
  employmentTypes: GenericField<EmploymentType>[],
  lang: string,
) {
  return employmentTypes.map(
    (employmentType: { value: EmploymentType }) => translation[employmentType.value][lang],
  );
}

export default translation;
